import posthog from 'posthog-js';

const getEnv = (key: string) => {
  // Check Vite/ESM standard
  if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env[key]) {
    return (import.meta as any).env[key];
  }
  // Check global process polyfill
  return (window as any).process?.env?.[key] || '';
};

const API_KEY = getEnv('VITE_POSTHOG_KEY');
const API_HOST = getEnv('VITE_POSTHOG_HOST') || 'https://app.posthog.com';

// Prevent initializing multiple times
let initialized = false;

export const Analytics = {
  init: () => {
    if (initialized) return;
    
    if (API_KEY) {
      posthog.init(API_KEY, {
        api_host: API_HOST,
        loaded: (ph) => {
          if ((import.meta as any).env?.DEV) ph.opt_out_capturing(); // Optional: disable in dev
        }
      });
      initialized = true;
    } else {
      console.log('📊 Analytics initialized in Mock Mode (Console Logging)');
      initialized = true;
    }
  },

  identify: (userId: string, traits?: Record<string, any>) => {
    if (API_KEY) {
      posthog.identify(userId, traits);
    } else {
      console.log(`[Analytics] Identify: ${userId}`, traits);
    }
  },

  track: (event: string, properties?: Record<string, any>) => {
    if (API_KEY) {
      posthog.capture(event, properties);
    } else {
      console.log(`[Analytics] Track: ${event}`, properties);
    }
  },

  pageView: () => {
    // PostHog handles page views automatically if configured, but manual calls help in specific SPAs
    if (API_KEY) {
      // posthog.capture('$pageview'); // Often automatic
    }
  }
};